import { Component, Inject, OnInit } from '@angular/core';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-image-crop-modal', imports: [ImageCropperComponent, TranslateModule], templateUrl: './image-crop-modal.component.html', styleUrl: './image-crop-modal.component.scss'
})
export class ImageCropModalComponent implements OnInit {
  croppedImage: string = '';

  constructor(
    public dialogRef: MatDialogRef<ImageCropModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
  }

  imageCropped(event: ImageCroppedEvent) {
    if (event.blob) {
      const reader = new FileReader();
      reader.onload = () => {
        this.croppedImage = reader.result as string; // base64
      };
      reader.readAsDataURL(event.blob);
    }
  }

  onSave() {
    // Make sure croppedImage is not empty
    if (this.croppedImage) {
      this.dialogRef.close(this.croppedImage);
    } else {
      // fallback: if user didn't crop, send null
      this.dialogRef.close(null);
    }
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}